<template>
    <div>
        <van-nav-bar
            title="我的收藏"
            left-text="返回"
            left-arrow
            @click-left="$router.back()"
        />
        <flat-list url="UserLog/listPage" list-class="margin-top" :data="{orderBy:'create_time',sortBy:'desc',type:'favorite'}">
            <bids-item slot-scope="scope" :info="scope.row.slug"></bids-item>
        </flat-list>
    </div>
</template>

<script>
export default {
    name: "favorite"
}
</script>
